// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const ur: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'کیسے کھیلیں',
  'howto.pieces.heading': 'ٹکڑے',
  'howto.pieces.source': 'منبع',
  'howto.pieces.mirror': 'آئینہ',
  'howto.pieces.switch': 'سوئچ',
  'howto.pieces.exit': 'خروج',
  'howto.pieces.wall': 'دیوار',
  'howto.controls.heading': 'کنٹرول',
  'howto.controls.clickSlot.line1': 'خانے پر کلک کریں',
  'howto.controls.clickSlot.line2': 'آئینہ رکھیں',
  'howto.controls.dragMirror.line1': 'آئینہ کھینچیں',
  'howto.controls.dragMirror.line2': 'گھمائیں',
  'howto.controls.rightClick.line1': 'دایاں کلک',
  'howto.controls.rightClick.line2': 'آئینہ ہٹائیں',
  'howto.controls.hint': 'ماؤس وہیل: 1° کی باریک گردش۔   آئینے پر ٹیپ: 15° کی گردش۔',
  'howto.objective.line1': 'ہر سوئچ کو روشن کریں — خروج کا قفل خود کھل جاتا ہے۔',
  'howto.objective.line2': 'پھر خروج پر کلک کریں۔ جتنے کم آئینوں سے ممکن ہو حل کریں۔',

  'howtoColor.title': 'رنگ اور منشور',
  'howtoColor.pieces.heading': 'نئے ٹکڑے',
  'howtoColor.pieces.prism': 'منشور',
  'howtoColor.pieces.redSwitch': 'سرخ سوئچ',
  'howtoColor.pieces.yellowSwitch': 'زرد سوئچ',
  'howtoColor.pieces.whiteSwitch': 'سفید سوئچ',
  'howtoColor.how.heading': 'یہ کیسے کام کرتے ہیں',
  'howtoColor.how.line1': 'سفید شعاع سرخ، سبز اور نیلی روشنی کو ایک ساتھ لے کر چلتی ہے۔',
  'howtoColor.how.line2':
    'منشور سفید روشنی کو اپنے تین اطراف پر تین رنگین شعاعوں میں تقسیم کرتا ہے۔',
  'howtoColor.how.line3': 'رکھے ہوئے منشور پر کلک کرکے اس کا داخلی رخ گھمائیں۔',
  'howtoColor.switches.line1': 'سوئچوں پر رنگین نقطے ہوتے ہیں — یہی ان کا مطلوبہ رنگ ہے۔',
  'howtoColor.switches.line2': 'زرد سوئچ (سرخ + سبز نقطے) کو دونوں رنگ ایک ساتھ چاہئیں۔',
  'howtoColor.switches.line3': 'سفید سوئچ (تینوں رنگ) کو سرخ، سبز اور نیلا ایک ساتھ چاہئیں۔',

  'options.hints.label': 'پہیلیوں میں اشاراتی زاویے دکھائیں',
  'options.hints.help': 'ہر انعکاس پر آنے والی اور منعکس شدہ شعاع کے درمیان زاویہ دکھاتا ہے۔',

  'level.01-intro.title': 'ہیلو روشنی',
  'level.02-two-mirrors.title': 'دو موڑ',
  'level.03-corner.title': 'راستے میں دیوار',
  'level.04-two-targets.title': 'دو نشانے',
  'level.05-tight.title': 'تنگ',
  'level.06-hello-color.title': 'ہیلو رنگ',
  'level.07-pick-a-side.title': 'ایک طرف چنیں',
  'level.08-yellow.title': 'زرد',
  'level.09-magenta.title': 'میجنٹا',
  'level.10-spectrum.title': 'طیف',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'قائمہ',
  'puzzle.hint.angleType.acute': 'حادہ',
  'puzzle.hint.angleType.obtuse': 'منفرجہ',
  'puzzle.hint.label': '{angle}°\n{type}',
};
